module.exports = __webpack_public_path__ + "assets/media/s3.d56caadf.mp3";